var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconawesomeClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 22,
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-clock",
    "data-name": "Icon awesome-clock",
    d: "M14.563.563a14,14,0,1,0,14,14A14,14,0,0,0,14.563.563Zm3.223,19.764-4.979-3.619a.682.682,0,0,1-.277-.548v-9.5a.679.679,0,0,1,.677-.677h2.71a.679.679,0,0,1,.677.677v7.773l3.585,2.608a.677.677,0,0,1,.147.948l-1.592,2.19A.682.682,0,0,1,17.786,20.326Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeClock);
export default __webpack_public_path__ + "static/media/Icon awesome-clock.0f47cbfb3fb838b39b1ee8a8ae4433b7.svg";
export { ForwardRef as ReactComponent };